<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "@/assets/site/css/bootstrap.min.css";
import "@/assets/site/css/style.scss";
import "@/assets/site/css/responsive.css";
import "@/assets/site/css/remixicon.css";

export default {
  name: "App",
};
</script>
